"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //     

// eslint-disable-next-line no-unused-vars


exports.default = LogoICGC;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LogoICGC = require("./LogoICGC.css");

var _LogoICGC2 = _interopRequireDefault(_LogoICGC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LogoICGC(props) {

	var logoProps = _extends({
		addText: false,
		position: "bottomRight",
		url: "http://www.icgc.cat/",
		logoType: "icgc-logo"
	}, props);

	return _react2.default.createElement(
		"div",
		{ className: props.addText ? _LogoICGC2.default.bottomRight : _LogoICGC2.default.bottomRight35px },
		_react2.default.createElement("a", { className: logoProps.addText ? _LogoICGC2.default.icgclogo : _LogoICGC2.default.icgclogotxt, target: "_blank", title: "Institut Cartogr\xE0fic i Geol\xF2gic de Catalunya", rel: "noopener noreferrer", href: logoProps.url, "aria-label": "Icgc" }),
		logoProps.addText && _react2.default.createElement(
			"div",
			{ className: _LogoICGC2.default.logoText },
			logoProps.addText
		)
	);
}

LogoICGC.propTypes = {
	position: _propTypes2.default.string,
	addText: _propTypes2.default.string,
	url: _propTypes2.default.string,
	logoType: _propTypes2.default.string,
	visor: _propTypes2.default.bool
};
